import { Link } from "react-router-dom";
import icons from "../constants/icons";
import Img from "./Img";

const List = ({ data, padding = "20px 0" }) => {
  return (
    <div className="movies" style={{ padding }}>
      {data?.map((item, index) => (
        <Link
          to={item?.path ?? "/102/test"}
          className="movie-list"
          key={Math.random()}
          title={item?.title}
        >
          <div className="cover">
            <img src={icons.play} />
          </div>

          <div style={{ marginTop: 12 }} />

          {item?.image && <Img src={item?.image} alt={item?.title} />}

          <div className="info" style={{ height: 70 }}>
            <div className="title">{item?.title}</div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default List;
